import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-system-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_PcPageMain = _resolveComponent("PcPageMain")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { style: {"height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        class: "header-layout-defined",
        style: {"height":"64px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "container-layout-defined" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, { class: "main-layout-defined" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_PcPageMain)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}